module.exports = __webpack_public_path__ + "img/neurodiversity.056c5780.svg";